import React from "react";
import { Star, Check } from "lucide-react";
import { brand } from "../data/site";

// Hero trust strip.
//
// Once Pepla has a Google Business Profile with reviews, set brand.rating and
// brand.googleReviewUrl in src/data/site.js and this becomes the rating pill.
// Until then it states things that are true today instead of borrowing
// credibility the business hasn't earned yet.
//
// Google's multicolor logo can't be recolored under their brand guidelines,
// so the pill names Google in plain text and uses the site palette instead.
const TrustStrip = ({ className = "", points, labels }) => {
  const items = points || [
    "Complimentary inspections & estimates",
    "7 days a week, 7am–7pm",
    "Every product named in writing",
  ];

  if (brand.rating && brand.googleReviewUrl) {
    return (
      <a
        href={brand.googleReviewUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${labels?.rated || "Rated"} ${brand.rating} ${labels?.outOf || "out of 5 on Google — read our reviews"}`}
        className={`group inline-flex items-center gap-3 rounded-full border border-brand/45 bg-ink/55 backdrop-blur-sm pl-4 pr-5 py-2.5 transition-colors hover:border-brand ${className}`}
      >
        <span className="flex items-center gap-0.5" aria-hidden="true">
          {[...Array(5)].map((_, i) => <Star key={i} size={15} className="fill-brand text-brand" />)}
        </span>
        <span className="flex items-baseline gap-1.5 leading-none">
          <span className="font-heading text-xl text-white">{brand.rating}</span>
          <span className="text-white/60 text-xs tracking-wide group-hover:text-white/80 transition-colors">
            {labels?.onGoogle || "on Google Reviews"}
          </span>
        </span>
      </a>
    );
  }

  return (
    <ul className={`flex flex-wrap items-center gap-x-5 gap-y-2.5 ${className}`}>
      {items.map((t) => (
        <li key={t} className="inline-flex items-center gap-2 text-white/75 text-sm">
          <span className="w-5 h-5 rounded-full bg-brand/20 flex items-center justify-center shrink-0">
            <Check size={12} className="text-brand" />
          </span>
          {t}
        </li>
      ))}
    </ul>
  );
};

export default TrustStrip;
